import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
  Inspection,
  InspectionList,
  InspectionDetailNew,
  InspectionDetailUpdate,
  InspectionUpdateLocation,
  InspectionForSharedLock
} from "../../_objects/inspection";

import { SubjectFilter } from "../storage.service";
import { ApiService } from "../base/api-base.service";
import { InspectionContractService } from "../interfaces/inspection-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { InspectionOfflineService } from "../offline/inspection-offline.service";
import { InspectionOnlineService } from "../online/inspection-online.service";

@Injectable()
export class InspectionService extends ApiService<InspectionContractService> implements InspectionContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: InspectionOfflineService,
    protected onlineService: InspectionOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // IS01 GET /api/v1/inspections
  // page.indexは1はじまり
  getInspections(
    statusCode?: string,
    subjectFilter?: SubjectFilter,
    isOwn?: boolean,
    sort?: { active: string; direction: string },
    page?: { index: number; size: number }
  ): Observable<InspectionList> {
    return this.service.getInspections(statusCode, subjectFilter, isOwn, sort, page);
  }

  // IS02 GET /api/v1/inspections/{inspectionId}
  getInspection(id: string, aliveOnly?: boolean): Observable<Inspection> {
    return this.service.getInspection(id, aliveOnly);
  }

  // IS09 GET /api/v1/inspections/checkedout
  getCheckedOutInspections(): Observable<Inspection[]> {
    return this.service.getCheckedOutInspections();
  }

  // IS03 POST /api/v1/inspections
  addInspection(inspection: InspectionDetailNew): Observable<Inspection> {
    return this.service.addInspection(inspection);
  }

  // IS04 PUT /api/v1/inspections/{inspectionId}
  updateInspection(inspection: InspectionDetailUpdate): Observable<Inspection> {
    return this.service.updateInspection(inspection);
  }

  // IS05 DELETE /api/v1/inspections/{inspectionId}
  deleteInspection(id: string): Observable<any> {
    return this.service.deleteInspection(id);
  }

  // IS07 PUT /api/v1/inspections/{inspectionId}/inspectionLocations
  updateInspectionLocations(inspection: InspectionUpdateLocation): Observable<Inspection> {
    return this.service.updateInspectionLocations(inspection);
  }

  // IS08 PUT /api/inspections/{inspectionId}/sharedLock
  updateInspectionSharedLock(inspForSharedLock: InspectionForSharedLock): Observable<Inspection> {
    return this.service.updateInspectionSharedLock(inspForSharedLock);
  }
}
